import { render, staticRenderFns } from "./ConversationListItem.vue?vue&type=template&id=ecfdc5fa&scoped=true&"
import script from "./ConversationListItem.vue?vue&type=script&lang=ts&"
export * from "./ConversationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationListItem.vue?vue&type=style&index=0&id=ecfdc5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfdc5fa",
  null
  
)

/* custom blocks */
import block0 from "./ConversationListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
